module.exports = __webpack_public_path__ + "img/case19.9833781a.png";